<template lang="pug">
  div
    component.seo-only(:is="isIndex ? 'h2' : 'h1'") 聯絡佑昇生殖中心與門診資訊
    OutPatientTime
    TrafficInfomation
</template>

<script>
import OutPatientTime from "@/components/OutPatientTime.vue";
import TrafficInfomation from "@/components/TrafficInfomation.vue";

export default {
  name: "ContactUs",

  components: {
    OutPatientTime,
    TrafficInfomation,
  },

  props: {
    isIndex: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
};
</script>
